//Done

import React, {useState, useEffect} from 'react';
import { Table, Button, Row, Col, Popconfirm } from 'antd';
import moment from 'moment';
import StudentInfoModal from './StudentInfoModal';
import StudentCoursesTable from './StudentCoursesTable'

export default function StudentDetail (props) {
  const [infoSource, setInfoSource] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [dataIsLoading, setDataIsLoading] = useState(false);
  const [modalRowRecord, setModalRowRecord] = useState(null);
  const [modalIsEditing, setModalIsEditing] = useState(null);

  useEffect(() => {
      fetch(`https://kh-studentrecordsystem.herokuapp.com/studentsInfo/${props.match.params.id}`)
          .then(response => response.json())
          .then(data => {setInfoSource(data)})
          .catch(err => console.log(err))
  }, [props.match.params.id])

  const infoColumns = [
    {
      title: 'Current Grade',
      dataIndex: 'grade',
      width: "5%",
    },
    {
      title: 'Current Semester',
      dataIndex: 'semester',
      width: "5%",
    },
    {
      title: 'First Name',
      dataIndex: 'firstName',
      width: "20%",
    },
    {
      title: 'Last Name',
      dataIndex: 'lastName',
      width: "20%",
    },
    {
      title: 'Date Of Birth',
      dataIndex: "dob",
      width: "20%",
    },
    {
      title: 'Age',
      dataIndex: "age",
      width: "5%",
    },
    {
      title: 'Gender',
      dataIndex: "gender",
      width: "5%",
    },
    {
      title: 'Emergency Contact',
      dataIndex: "contact",
      width: "15%",
    },
    {
      title: 'Operation',
      dataIndex: 'operation',
      width: "5%",
      render: (text, record) => ( 
        <Button type="text" onClick={() => {handleInfoEdit(record)}} className="opBtn" style={{color: "blue"}}>Edit</Button>
      )
    },     
  ]

  const handleInfoEdit = (record) => {
    setModalRowRecord(record);
    setModalIsEditing(true);
    setModalVisible(true);
  }

  const handleInfoUpdate = (record) => {
    let newGradeId = '';
    if (modalRowRecord.grade === record.studentGrade) {
      newGradeId = modalRowRecord.gradeId;
    } else {
      newGradeId = record.studentGrade;
    }
    let newSemesterId = '';
    if (modalRowRecord.semester === record.studentSemester) {
      newSemesterId = modalRowRecord.semesterId;
    } else {
      newSemesterId = record.studentSemester;
    }
    const newData = {
      gradeId: newGradeId,
      semesterId: newSemesterId,
      firstName: record.firstName,
      lastName: record.lastName,        
      dob: moment(record.dob).format("DD-MMM-YYYY"),
      age: record.age,
      gender: record.gender,
      contact: record.contact,        
    }
    setDataIsLoading(true);
    fetch(`https://kh-studentrecordsystem.herokuapp.com/studentsInfo/${props.match.params.id}`, {
      method: 'PUT',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify(newData),
    })
      .then(data => {
        fetch(`https://kh-studentrecordsystem.herokuapp.com/studentsInfo/${props.match.params.id}`)
          .then(response => response.json())
          .then(data => {
            setInfoSource(data);
            setModalVisible(false);
            setDataIsLoading(false);
          })
          .catch(err => console.log(err))
      })
      .catch(err => console.log(err))
  }  

  const handleStudentDel = () => {
    fetch(`https://kh-studentrecordsystem.herokuapp.com/studentsInfo/${props.match.params.id}`, {
      method: 'DELETE',
      headers: {'Content-Type': 'application/json'},
    })
      .then(data => {window.location.href="/studentsInfo"})
  }

  return (
    <div>
      <Row justify="center">
        <Col xs={23} lg={{span: 23, offset: 1}} xl={{span: 23, offset: 3}}>
          <Table
            rowKey={record => record._id}
            bordered
            dataSource={infoSource}
            columns={infoColumns}
            pagination={false}
            title={() => {return (
              <div className="studentTableHead">
                Information
              </div>
            )}}
            loading={dataIsLoading}
          />

          <StudentInfoModal
            modalIsEditing={modalIsEditing}
            visible={modalVisible}
            record={modalRowRecord}
            onUpdate={handleInfoUpdate}
            onCancel={() => {
              setModalRowRecord(null)
              setModalVisible(false);
            }}
          />
        </Col>
      </Row>

      <Row justify="center">
        <Col xs={23} lg={{span: 23, offset: 1}} xl={{span: 23, offset: 3}}>
            <StudentCoursesTable id={props.match.params.id}/>
        </Col>
      </Row>
      
      <Row justify="center">
        <Col xs={23} lg={{span: 23, offset: 1}} xl={{span: 23, offset: 3}}>
          <Popconfirm title="All information related to this student(including basic and courses) will be delete! Confirm? " onConfirm={() => handleStudentDel()}>
              <Button type="primary" shape="round" danger style={{width: "100%", fontWeight: "bolder", fontSize: "30px", lineHeight: "50px", height: "50px", padding: "0"}}>Delete</Button>
          </Popconfirm>
        </Col>
      </Row>
    </div>
  );
}